import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import UserActions from 'actions/UserActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ForgotPasswordBindings from 'analytics/bindingMethods/components/globalModals/forgotPasswordModal/ForgotPasswordBindings';
import ResetPasswordConfirmationModalEN from 'components/GlobalModals/ResetPasswordConfirmationModal/locales/ResetPasswordConfirmationModal_en_US';
import ResetPasswordConfirmationModalFR from 'components/GlobalModals/ResetPasswordConfirmationModal/locales/ResetPasswordConfirmationModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(ResetPasswordConfirmationModalEN, ResetPasswordConfirmationModalFR);

const localization = createStructuredSelector({
    emailSent: getTextFromResource(getText, 'emailSent'),
    confirmButton: getTextFromResource(getText, 'confirmButton'),
    confirmationMessage: getTextFromResource(getText, 'confirmationMessage'),
    confirmationMessage2: getTextFromResource(getText, 'confirmationMessage2'),
    confirmationMessagePasskey: getTextFromResource(getText, 'confirmationMessagePasskey'),
    didntGetEmail: getTextFromResource(getText, 'didntGetEmail'),
    resend: getTextFromResource(getText, 'resend'),
    error: getTextFromResource(getText, 'error'),
    errorMessage: getTextFromResource(getText, 'errorMessage')
});

const fields = createStructuredSelector({
    localization,
    resetPasswordConfirmationOnDismiss: state => state.modals.resetPasswordConfirmationOnDismiss
});

const functions = dispatch => ({
    dispatchCloseModal: () => {
        dispatch(Actions.showResetPasswordConfirmationModal({ isOpen: false }));
    },
    forgotPassword: (login, successCallback, failureCallback, source, options) => {
        dispatch(UserActions.forgotPassword(login, successCallback, failureCallback, source, options));
    },
    emailResentTracking: ForgotPasswordBindings.emailResent
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onDismiss: () => {
        dispatchProps.dispatchCloseModal();

        // Call the custom onDismiss callback if it exists
        if (stateProps.resetPasswordConfirmationOnDismiss) {
            stateProps.resetPasswordConfirmationOnDismiss();
        }
    }
});

const withResetPasswordConfirmationModalProps = wrapHOC(connect(fields, functions, mergeProps));

export {
    withResetPasswordConfirmationModalProps, fields, functions
};
